import { Component } from '@angular/core';
import { IconRegistry } from '../services/helpers/icons-registry.service';
import { State } from '../state/app-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public stateService: State) {
    
  }
}
